/**
 * 環境識別子
 */
export type InvitationEnv = 'dev' | 'stg' | 'fl001' | 'fl002';

/**
 * 招待トークン検証のレスポンス
 */
export interface InvitationValidateResponse {
  valid: boolean;
  invitation_token: string;
  company_code: string;
  company_name: string;
  staff_code: string;
  staff_name: string;
  email: string;
  expires_at: string;
  /** エラーコード（valid=false の場合に設定） */
  error_code?: InvitationErrorCode;
  /** エラーメッセージ（valid=false の場合に設定） */
  error_message?: string;
}

/**
 * 環境とcompany_codeからFLARO URLを生成
 * @param env 環境識別子（必須）
 * @param companyCode 会社コード
 */
export const buildFlaroUrl = (env: InvitationEnv, companyCode: string): string => {
  switch (env) {
    case 'dev':
      return 'https://dev.flaro.jp';
    case 'stg':
      return `https://${companyCode}.stg.flaro.jp`;
    case 'fl001':
      return `https://${companyCode}.flaro.jp`;
    case 'fl002':
      return `https://${companyCode}.fl002.flaro.jp`;
    default:
      return 'https://app.flaro.jp';
  }
}

/**
 * 招待エラーコード
 */
export type InvitationErrorCode =
  | 'TOKEN_NOT_FOUND'
  | 'TOKEN_EXPIRED'
  | 'ALREADY_LINKED'
  | 'TOKEN_UNLINKED'
  | 'TOKEN_REVOKED'
  | 'INVALID_STATUS';

/**
 * 招待エラーレスポンス
 */
export interface InvitationErrorResponse {
  code: InvitationErrorCode;
  message: string;
}

/**
 * エラーコードに対応するユーザー向けメッセージ
 */
export const INVITATION_ERROR_MESSAGES: Record<InvitationErrorCode, string> = {
  TOKEN_NOT_FOUND: '招待が見つかりません。管理者に再発行を依頼してください。',
  TOKEN_EXPIRED: '招待の有効期限が切れています。管理者に再発行を依頼してください。',
  ALREADY_LINKED: 'この招待は既に使用されています。',
  TOKEN_UNLINKED: 'この招待は連携解除済みです。管理者に再発行を依頼してください。',
  TOKEN_REVOKED: 'この招待は無効化されています。管理者に確認してください。',
  INVALID_STATUS: 'トークンのステータスが不正です。管理者に確認してください。',
};
